import React from 'react';
import styled from '@emotion/styled';
import 'typeface-gfs-didot';

const Component: React.FCX = ({ className, children }) => <main className={className}>{children}</main>;

const StyledComponent = styled(Component)`
  width: 100vw;
  min-height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  font-family: Roboto, 'Noto Sans JP', 'Yu Gothic', Meiryo, 'Hiragino Kaku Gothic ProN', 'Hiragino Sans', sans-serif;
/*
  @media only screen and (min-width: 801px) {

    width: 70vw;
    padding-left: 30vw;
  }

  @media only screen and (min-width: 1001px) {
    width: 100vw;
    padding-left: 300px;
  }
*/
`;

export default StyledComponent;
